<template>
  <div id="app">
    <main>


      
<!-- Modal -->
<div class="modal fade" id="modal-presentation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"><strong>Comunicado</strong></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
         <img src="./assets/modal.jpg" alt="" style="max-width: 70%;">
      </div>
      <div class="modal-footer text-center">
        <button type="button" class="btn btn-al-azul-solid btn-sm btn-card" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>
     
   <!-- Menu en movil -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-pesca fixed-top fixed-top" id="nav">
      <div class="container">
         
          <div class="col-4">
            <div class="row">
              <div class="col-2">
                  <button
                    class="navbar-toggler toggler-armaq"
                    type="button"
                    data-toggle="collapse"
                    data-target=".navbars"
                    aria-controls=".navbars"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span class="navbar-toggler-icon toggler-armaq-icon"></span>
                  </button>
              </div>
              <div class="col-10">
                <form class="navbar-form d-none d-lg-block" role="search" id="navBarSearchForm">
                    <div class="input-group">
                      
                        <input type="text" class="formulario-cabecera form-control search-control " v-model="search_data" placeholder="Busca aquí el producto de tu interés" maxlength="50">
                      
                          <template v-if='search_data=="" || search_data.length <=2'>
                            <button type="submit" disabled class="btn btn-al-rojo-solid search-buttons">
                              <i class="fa fa-search"></i>
                            </button>
                          </template>
                          <template v-else>
                            <router-link tag="button" type="submit" :key="'search'+this.search_data" :to='{ path: "/productos/0/1/0/0/0/0/"+search_data+"" }' class="btn btn-al-rojo-solid search-buttons">
                              <i class="fa fa-search"></i>
                            </router-link>
                          </template>
                          
                      <!--   <button class="btn btn-al-rojo-solid search-buttons" @click="search_product()"><i class="fa fa-search"></i></button> -->
                        
                    </div>
                  </form>
              </div>
            </div>
           
            
            
          </div>
          <div class="col-4">
            <router-link to="/" alt="Armaq">
              	<img alt="Armaq" class="logo-armaq" src="./assets/logo.png"> 
            </router-link>
          </div>
          <div class="col-4">
            
            <a  class="cart" data-toggle="modal" data-target="#exampleModal">
              <i class="fa fa-shopping-cart mr-1"></i>
              <span class='badge badge-danger' id='lblCartCount'> {{this.cartProducts.length}} </span> 
            </a>

            <router-link to="/login" class="fa fa-user fa-networks" v-if="!logged"></router-link>
            <a v-if="logged"
                    class="fa fa-user fa-networks dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  ></a>
                  <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <router-link to="/perfil" class="dropdown-item">Mi Cuenta</router-link>
                    <router-link to="/pedidos" class="dropdown-item">Mis Pedidos</router-link>
                    <router-link to="/carrito" class="dropdown-item">Mi Carrito</router-link>
                    <router-link to="/" class="dropdown-item" @click.native="loc_logout">Cerrar Sesión</router-link>
                  </div>
            <a href="https://www.facebook.com/armaqpesca" target="_blank" class=" fa fa-facebook fa-networks facebook-mobile"></a>
            
           
          </div>
          <div class="col-12 d-lg-none">
            <form class="navbar-form" role="search" id="navBarSearchForm">
                    <div class="input-group" style="padding-top: 10px;">
                      
                    
                       
                        <input type="text" class="formulario-cabecera form-control search-control " v-model="search_data" placeholder="Busca aquí el producto de tu interés" maxlength="50">
                      
                          <template v-if='search_data=="" || search_data.length <=2'>
                            <button type="submit" disabled class="btn btn-al-rojo-solid search-buttons">
                              <i class="fa fa-search"></i>
                            </button>
                          </template>
                          <template v-else>
                            <router-link tag="button" type="submit" :key="'search'+this.search_data" :to='{ path: "/productos/busqueda/"+search_data+"/0"}' class="btn btn-al-rojo-solid search-buttons">
                              <i class="fa fa-search"></i>
                            </router-link>
                          </template>
                          
                      <!--   <button class="btn btn-al-rojo-solid search-buttons" @click="search_product()"><i class="fa fa-search"></i></button> -->
                        
                    </div>
                  </form>
          </div>
      </div>
      <div class="container d-lg-none">
        <div class="navbar-collapse collapse navbars" id="navbar2">
              <ul class="navbar-nav mr-auto">

                <li class="nav-item submenu-item">
                    <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink" role="button" aria-haspopup="true" aria-expanded="false">
                      Inicio
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink">
                      <template v-for="section in section_list">
                        <router-link v-if="section.cod_section!=12 && section.cod_section!=15" tag="a" :to="'/' + section.url_es" class="dropdown-item" v-bind:key="section.cod_section"><i class="fa fa-angle-double-right"></i>{{section.name_sec_es}}</router-link>
                      </template>
                    </div>
                  
                </li> 
     

                <template v-for="(category, index) in father_categories">
                  <li class="nav-item submenu-item">
                  <template v-if='!(category.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                      <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink" role="button" aria-haspopup="true" aria-expanded="false">
                        {{category.product_type_desc_es}}
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink">
                        <template v-for="(subcategory, index2) in category.sub_categories">
                          <li class="nav-item submenu-item">

                            <template v-if='!(subcategory.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                                
                                <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink2" role="button" aria-haspopup="true" aria-expanded="false"  @click="setSearch_category(subcategory)" :key='"toogle-menu-child-1"+index2' >
                                  {{subcategory.product_type_desc_es}}
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink2" :key='"navbar-child-1"+index2'>
                                  <template v-for="(son_subcategory, index3) in subcategory.sub_categories">
                                    <a class="dropdown-item" @click="setSearch_subcategory(son_subcategory.id_category,son_subcategory.product_type_desc_es, son_subcategory.category_reference)" :key='"menu-child-2"+index3' >{{son_subcategory.product_type_desc_es}}</a>
                                  </template>
                                </div>

                            </template>
                            <template v-else>
                              <a class="dropdown-item" id="navbarDropdownSubMenuLink" role="button" @click='setSearch_subcategory(subcategory.sub_categories.find(subcate => subcate.product_type_desc_es === "#").id_category,subcategory.product_type_desc_es)'>
                                  {{subcategory.product_type_desc_es}}
                              </a>
                            </template>

                          </li>
                        </template>
                      </div>
                  </template>
                  <template v-else>
                      <a class="dropdown-item" @click='setSearch_category(category.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                        {{category.product_type_desc_es }}
                      </a>
                  </template> 
                  </li>
                </template>
                <template v-for="section in section_list">
                  <li v-if="section.cod_section==12 || section.cod_section==15" class="nav-item submenu-item" v-bind:key="section.cod_section">
                        <router-link tag="a" :to="'/' + section.url_es" class="dropdown-item"><i class="fa fa-angle-double-right"></i>{{section.name_sec_es}}</router-link>
                  </li>
                </template>

                
               
               
              </ul>
        </div>
      </div>
        
    </nav>

    <!-- Menu en escritorio -->
     <nav class="navbar navbar-expand-lg navbar-dark bg-pesca fixed-top fixed-top-2 d-none d-lg-block" id="navbar-secundario">
      <div class="container">
        <div class="navbar-collapse collapse navbars" id="navbar2">
              <ul class="navbar-nav mr-auto">
                <li class="nav-item submenu-item">
                    <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink" role="button" aria-haspopup="true" aria-expanded="false">
                      Inicio
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink">
                      <template v-for="section in section_list">
                        <router-link v-if="section.cod_section!=12 && section.cod_section!=15" tag="a" :to="'/' + section.url_es" class="dropdown-item">{{section.name_sec_es}}</router-link>
                      </template>
                    </div>
                  
                </li>

                
                
                 <template v-for="(category, index) in father_categories">
                  <li class="nav-item submenu-item">
                  <template v-if='!(category.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                      <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink" role="button" aria-haspopup="true" aria-expanded="false">
                        {{category.product_type_desc_es}}
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink">
                        <template v-for="(subcategory, index2) in category.sub_categories">
                          <li class="nav-item submenu-item submenu-item-2nd">

                            <template v-if='!(subcategory.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                                
                                <a class="dropdown-item dropdown-toggle" data-toggle="dropdown" id="navbarDropdownSubMenuLink2" role="button" aria-haspopup="true" aria-expanded="false"  @click="setSearch_category(subcategory)" :key='"toogle-menu-child-1"+index2' >
                                  {{subcategory.product_type_desc_es}}
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink2" :key='"navbar-child-1"+index2'>
                                  <template v-for="(son_subcategory, index3) in subcategory.sub_categories">
                                    <a class="dropdown-item" @click="setSearch_subcategory(son_subcategory.id_category,son_subcategory.product_type_desc_es, son_subcategory.category_reference)" :key='"menu-child-2"+index3' >{{son_subcategory.product_type_desc_es}}</a>
                                  </template>
                                </div>

                            </template>
                            <template v-else>
                              <a class="dropdown-item" id="navbarDropdownSubMenuLink" role="button" @click='setSearch_subcategory(subcategory.sub_categories.find(subcate => subcate.product_type_desc_es === "#").id_category,subcategory.product_type_desc_es)'>
                                  {{subcategory.product_type_desc_es}}
                              </a>
                            </template>

                          </li>
                        </template>
                      </div>
                  </template>
                  <template v-else>
                      <a class="dropdown-item" @click='setSearch_category(category.sub_categories.find(subcate => subcate.product_type_desc_es === "#"))'>
                        {{category.product_type_desc_es }}
                      </a>
                  </template> 
                  </li>
                </template>
                <template v-for="section in section_list">
                   <li v-if="section.cod_section==12 || section.cod_section==15" class="nav-item submenu-item"  v-bind:key="section.cod_section">
                        <router-link tag="a" :to="'/' + section.url_es" class="dropdown-item">{{section.name_sec_es}}</router-link>
                   </li>
                </template>

              </ul>

             
        </div>
      </div>
    </nav>

    <div class="modal right fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h6 class="modal-title" id="myModalLabel">Carrito ({{cartProducts.length}}) Items</h6>
              </div>
              <div class="modal-body">
                <template v-if="cartProducts.length > 0">
                  <div class="col-sm-12 text-center" style="padding-top: 20px; border: #ced7df 2px dotted;" v-for="(item, index) in cartProducts" :key="index">
                  <img
                    class="imagen-cover"
                    v-bind:src='imgPreUrl+ item.photo_product +"x320.jpg"'
                    alt="Card image cap"
                    >
                      <h6>{{item.name_product_es}}</h6>
                      <p style="color:red;">{{item.price_product | currency}}</p><p>x ({{item.qty}} unidad(es))</p>
                      <p style="color:red;">{{item.price_product*item.qty | currency}}</p>
                
                  </div>
                </template>
                <template v-else>
                  <div class="error-template container">
                    <h2>Su carrito está vacío</h2>
                    <div class="error-details">Agrega productos ahora >></div>
                    <div class="error-actions">
                      <router-link to="/productos" data-dismiss="modal">Seguir comprando</router-link>
                    </div>
                  </div>
                </template>
              </div>
              <div class="modal-footer">

                <div class="row">
                  
                  <div v-if="cartProducts.length > 0" class="col-sm-12">
                    <a class="btn-al btn-al-md btn-success btn-ancho-total" v-bind:href='retornarMensaje()' target="_blank" title="Whatsapp"> Pedir por Whatsapp <i class="fa fa-whatsapp"></i></a>
                  </div>
                  <div class="col-sm-12">
                    <br>
                  </div>
                  <div class="col-sm-12">
                    <router-link tag="button" class="btn-al btn-al-md btn-al-rojo-solid btn-ancho-total" data-dismiss="modal" id="button" to="/carrito"> Ir al Carrito <i class="fa fa-shopping-cart"></i></router-link>
                  </div>
                </div>
                  
              </div>
            </div>
        </div>
    </div>

<router-view/>
</main>

<div class="suscripcion-widget d-none d-md-block" style="bottom: 200px; right: 0px;" data-toggle="modal" data-target="#myModal2">
  <a title="SUSCRÍBASE A ARMAQ"><img src="./assets/widget-cotizacion.png"> 
  </a>
</div>

<!--
<div class="suscripcion-widget d-none d-md-block" style="bottom: 200px; right: 0px;">
  <a id="webform_side_tab" title="SUSCRÍBASE A ARMAQ"><img src="./assets/widget-cotizacion.png"></a>
</div> -->

<back-to-top bottom="50px" right="50px">
  <button type="button" class="btn btn-info"><i class="fa fa-chevron-up"></i></button>
</back-to-top>
  
<!-- Footer -->
	<section id="footer">
    
      <div class="row">
        <!--
        <div class="col-sm-12">
         <div class="container">
           <div class="row">
             <div class="col-4">Suscríbase</div>
             <div class="col-8"><input type="text"></div>
           </div>
         </div>
        </div>
        -->


       
        <div class="col-sm-12 pie-caracteristicas">
          <div class="container">
            <div class="row row-pie-sin-margen">
              
              <div class="col-sm-12 col-md-6">
                <div class="row row-pie-sin-margen">
                  
                  <div class="col-6 div-icono-footer-izq"><i class="fa fa-truck iconos-pie"></i></div>
                  <div class="col-6 div-icono-footer-der"><p class="p-pie-caracteristicas"><strong>ENTREGAS</strong><br>Envíos a provincia</p></div>
                   
                </div>
              </div>
            
              <div class="col-sm-12 col-md-6">
                <div class="row row-pie-sin-margen">
                  <div class="col-6 div-icono-footer-izq"><i class="fa fa-phone-square iconos-pie"></i></div>
                  <div class="col-6 div-icono-footer-der"><p class="p-pie-caracteristicas"><strong>CONTÁCTENOS</strong><br>+51 946 085 317<br>01 2065800 (Anexo 109) </p></div>
                </div>
              </div>
             
             <!--
              <div class="col-sm-12 col-md-4">
                <div class="row row-pie-sin-margen">
                    
                  <div class="col-6 div-icono-footer-izq"><i class="fa fa-check-square-o iconos-pie"></i></div>
                  <div class="col-6 div-icono-footer-der"><p class="p-pie-caracteristicas"><strong>CALIDAD</strong><br>En Pesca Deportiva</p></div>
                 
                </div>
              </div>
              -->
             
              
            </div>
          </div>
        </div>

          

      </div>

     

    
    <div class="container">
			<div class="row text-center text-xs-center text-sm-left text-md-left row-principal-contenedor-pie">
			
				<div class="col-md-4 col-sm-12">
					<h5 class="h5-footer">Enlaces Rápidos</h5>
					<ul class="list-unstyled quick-links quick-links-primary">
              <template v-for="(section, index) in section_list">
                <li v-if="index<2" v-bind:key="section.cod_section"><router-link tag="a" :to="'/' + section.url_es" class="quick-link"><i class="fa fa-angle-double-right"></i>{{section.name_sec_es}}</router-link></li>
              </template>
              <template v-for="(section, index) in section_list">
                <li v-if="index>=2&&index<6" v-bind:key="section.cod_section"><router-link tag="a" :to="'/' + section.url_es" class="quick-link"><i class="fa fa-angle-double-right"></i>{{section.name_sec_es}}</router-link></li>
              </template>
					</ul>
				</div>
        <div class="col-md-4 col-sm-12">
          <ul class="list-unstyled quick-links">
            <li><router-link tag="a" to="/login" class="quick-link"><i class="fa fa-angle-double-right"></i>Iniciar Sesión</router-link></li>
            <li><router-link tag="a" to="/perfil" class="quick-link"><i class="fa fa-angle-double-right"></i>Mi cuenta</router-link></li>
            <li><router-link tag="a" to="/carrito" class="quick-link"><i class="fa fa-angle-double-right"></i>Mi carrito</router-link></li>
            <li><a href="http://www.armasperu.com.pe" target="_blank" class="quick-link"><i class="fa fa-angle-double-right"></i>Armaq: Armas y Municiones</a></li>
            <li><a href="https://cloud.horizontcpe.com/ConsultaComprobanteE/" target="_blank" class="quick-link"><i class="fa fa-angle-double-right"></i>Consultar Comprobante Electrónico</a></li>
            <li><router-link tag="a" to="/reclamo" class="quick-link">
            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -57 512 511" width="40px" class=""><g><path d="m496.84375.5h-169.453125c-29.605469 0-55.777344 14.949219-71.390625 37.691406-15.609375-22.742187-41.785156-37.691406-71.390625-37.691406h-169.453125c-8.371094 0-15.15625 6.785156-15.15625 15.15625v367.332031c0 8.371094 6.785156 15.15625 15.15625 15.15625h481.6875c8.371094 0 15.15625-6.785156 15.15625-15.15625v-367.332031c0-8.371094-6.785156-15.15625-15.15625-15.15625zm-169.453125 30.316406h154.292969v265.621094h-154.292969c-21.453125 0-41.09375 7.863281-56.230469 20.839844v-230.230469c-.003906-31.003906 25.222656-56.230469 56.230469-56.230469zm-142.78125 0c31.007813 0 56.230469 25.226563 56.230469 56.230469v230.230469c-15.136719-12.976563-34.777344-20.839844-56.230469-20.839844h-154.292969v-265.621094zm-154.292969 337.011719v-41.074219h154.292969c25.757813 0 47.523437 17.40625 54.15625 41.074219zm451.367188 0h-208.449219c6.632813-23.667969 28.398437-41.074219 54.15625-41.074219h154.292969zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m89.421875 115.019531h92.316406c8.371094 0 15.15625-6.785156 15.15625-15.15625 0-8.371093-6.785156-15.15625-15.15625-15.15625h-92.316406c-8.371094 0-15.160156 6.785157-15.160156 15.15625 0 8.371094 6.789062 15.15625 15.160156 15.15625zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m89.421875 179.089844h92.316406c8.371094 0 15.15625-6.785156 15.15625-15.15625s-6.785156-15.160156-15.15625-15.160156h-92.316406c-8.371094 0-15.160156 6.789062-15.160156 15.160156s6.789062 15.15625 15.160156 15.15625zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m89.421875 243.160156h92.316406c8.371094 0 15.15625-6.789062 15.15625-15.160156s-6.785156-15.15625-15.15625-15.15625h-92.316406c-8.371094 0-15.160156 6.785156-15.160156 15.15625s6.789062 15.160156 15.160156 15.160156zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m330.261719 115.019531h92.316406c8.371094 0 15.160156-6.785156 15.160156-15.15625 0-8.371093-6.789062-15.15625-15.160156-15.15625h-92.316406c-8.371094 0-15.15625 6.785157-15.15625 15.15625 0 8.371094 6.785156 15.15625 15.15625 15.15625zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m330.261719 179.089844h92.316406c8.371094 0 15.160156-6.785156 15.160156-15.15625s-6.789062-15.160156-15.160156-15.160156h-92.316406c-8.371094 0-15.15625 6.789062-15.15625 15.160156s6.785156 15.15625 15.15625 15.15625zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/><path d="m330.261719 243.160156h92.316406c8.371094 0 15.160156-6.789062 15.160156-15.160156s-6.789062-15.15625-15.160156-15.15625h-92.316406c-8.371094 0-15.15625 6.785156-15.15625 15.15625s6.785156 15.160156 15.15625 15.160156zm0 0" data-original="#4e4e4e" class="active-path" data-old_color="#4e4e4e" fill="#4e4e4e"/></g> </svg>
             Libro de Reclamaciones</router-link></li>
          </ul>
				</div>
        <div class="col-md-4 col-sm-12">
          <h5 class="h5-footer">Enlaces de interés</h5>
					<ul class="list-unstyled quick-links">
            <li><a href="https://www.armasperu.com.pe/documents/TERMINOS%20Y%20CONDICIONES%20ARMAQ.pdf" target="_blank"  class="quick-link"><i class="fa fa-angle-double-right"></i>Términos y Condiciones</a></li>
            <li><a href="https://www.armasperu.com.pe/documents/Servicio%20Tecnico.pdf" target="_blank"  class="quick-link"><i class="fa fa-angle-double-right"></i>Servicio Técnico</a></li>
            <li><a href="https://www.armasperu.com.pe/documents/Políticas%20de%20Protección%20de%20Datos%20Personales.pdf" target="_blank" class="quick-link"><i class="fa fa-angle-double-right"></i>Políticas de Protección de Datos Personales</a></li>
            <li><a href="https://www.armasperu.com.pe/documents/Politicas%20de%20Venta.pdf" target="_blank" class="quick-link"><i class="fa fa-angle-double-right"></i>Políticas de Venta</a></li>
            <li><a href="https://www.armasperu.com.pe/documents/Forma%20de%20Pago.pdf" target="_blank" class="quick-link"><i class="fa fa-angle-double-right"></i>Forma de Pago</a></li>
        	</ul>
				</div>
			</div>
			
			
     
		</div>

      <div class="row">
        <!--
        <div class="col-sm-12 zona-tarjetas">
          <div class="container">
            <div class="row-zona-tarjetas">
              <i class="fa fa fa-cc-visa fa-tarjetas"></i>
              <i class="fa fa fa fa-cc-mastercard fa-tarjetas"></i>
              <i class="fa fa fa fa-cc-amex fa-tarjetas"></i>
            </div>
          </div>
        </div>
        -->
        <div class="col-sm-12 pie-analysofti">
          <p class="p-pie-analysofti">Copyright © 2020 RUC 20108022702 ARMAQ SA. R.G.03448-2023-SUCAMC/GAMAC Todos los derechos reservados. <a class="a-pie-analysofti" href="http://www.analysofti.com" target="_blank">Desarrollado por:   <img src="./assets/analysofti-logo.png" width="100px" alt="Analysofti"></a>
                  <!--<a href="pdf/terminos/terminos-legales.pdf">Términos legales</a>.-->
                </p>
              
        </div>
      </div>
   
</section>

  
<div class="widget-cotitrack">
  <div class="btn-al btn-al-md btn-al-rojo-solid btn-cotizacion ancho-total" title="Suscríbase" data-toggle="modal" data-target="#myModal2">
		<div class="widget-cotitrack-icono"><i class="fa fa-envelope"></i></div>
		<div class="widget-cotitrack-texto">SUSCRÍBASE</div>
	</div>
   <!--
	<a href="https://api.whatsapp.com/send?phone=51922442902&text=Estimados!%20Necesito%20informaci%C3%B3n.%20&source=&data=" target="_blank" class="btn-al btn-al-md btn-al-verde-solid btn-extranet" title="Whatsapp">
		<div class="widget-cotitrack-icono"><i class="fa fa-whatsapp"></i></div>
		<div class="widget-cotitrack-texto">
		 Whatsapp</div>
	</a>
   -->
</div>

    <!-- MODAL -->    
    <div class="modal fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" @hide="algopasa">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-subscription">
          
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            
         
          <div class="modal-body">

            <form id="ema_signup_form" action="https://gem.godaddy.com/signups/subscribe/7e095ef4005e46eeab4342fc03170a81" accept-charset="UTF-8" method="post">
            
              <h3 style="font-weight: bold;">¡Suscríbase para recibir nuestras ofertas y novedades!</h3>
              <input name="utf8" type="hidden" value="✓"/>
              &nbsp;
              <div class="form-group mimi_field required">
                  <input id="signup_name" class="form-control input-subscription" name="signup[name]" type="text" placeholder="Ingrese su nombre completo" v-model="nombre_cliente" required/>
              </div>
              <div class="form-group mimi_field required">
                 <input id="signup_email" name="signup[email]" type="text" placeholder="Dirección de correo electrónico"
                 class="form-control input-subscription" v-model="correo_electronico" required/>
              </div>

              <div style="background: white; font-size:1px; height: 0; overflow: hidden">
                  <input type="text" name="390e24f9a78a995bcc312aee2d860935" style="font-size: 1px; width: 1px !important; height:1px !important; border:0 !important; line-height: 1px !important; padding: 0 0; min-height:1px !important;"/>
                  <input class="checkbox" type="checkbox" name="beacon"/>
              </div>
              &nbsp;
              <div class="mimi_field">
                  <input type="submit" @click="register_client" class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription" value="¡SUSCRÍBASE!" id="webform_submit_button"/>
                  <button type="button" class="btn-al btn-al-lg btn-al-rojo-solid btn-secciones button-right-subscription" data-dismiss="modal">Cerrar</button>&nbsp;
              </div>
            </form>

            <br>
            <template v-if="bar_suscription != false">
              <div class="col-xs-12 text-center">
              <div class="progress">
                <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>
              </div>
            </template>
            
            <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
            <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>


</div>

</template>

<script>
import { config_settings } from './config.js';
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import {
  isLoggedIn,
  getLoggedInUser
} from "./components/shared/service/authService";

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;
const CONFLICT = 409;

axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {

  metaInfo: {
      title: "Inicio",
      titleTemplate: '%s - Armaq'
  },
  data() {
    return {
      id_search_subcategory: 0,
      search_subcategory: "Todas las categorías",
      categories: [],
      father_categories: [],
      query: [],
      search_data: "",
      cartValue: 0,
      logged: false,
      user: new Object(),
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      correo_electronico: "",
      nombre_cliente: "",
      mensaje: "",
      mensaje_error: "",
      section_list: [],
      bar_suscription: false
    };
  },
  computed: mapState(["cartProducts", "loggedUser"]),
  watch: {
    '$route' () {
       $('#navbar1').collapse('hide');
      $('#navbar2').collapse('hide');
    }
  },
   mounted(){
    //$('#modal-presentation').modal('show');
  },
  methods: {
    algopasa() {

    },
    setSearch_category(value) {
      console.log("Estamos aqui: "+value.id_category)
      let category = typeof value.id_category == undefined ? 0 : value.id_category;
      this.search_subcategory = value.product_type_desc_es
      this.id_search_subcategory = 0;
      this.search_data="";
      this.$router.push("/productos/0/1/"+category+"/0/0/0");
    },
    
    obtener_secciones() {
        axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sections')
            .then(response => {
                this.section_list = response.data
            })
            .catch(error => {
              console.log("error");
        })
    },

    ocultar() {
      this.mensaje = ""
      this.mensaje_error = ""
    },

    reset_suscription() {
      this.correo_electronico = ""
      this.nombre_cliente = ""
    },

    godaddy_subscription() {

      var json_data = {
        "subscriber_name" : this.nombre_cliente,
        "subscriber_email" : this.correo_electronico
      }

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/godaddy_subscriptions',
        data: json_data
     })
      .then(response => {
        this.register_client();
      })
      .catch(error => {

        /*if(error.response.status == BAD_REQUEST) {
          this.mensaje_error = "Hubo un error al registrar su suscripción."
          this.reset_suscription();
        }

        if(error.response.status == CONFLICT) {
          this.mensaje_error = "El email ya se encuentra en uso. Por favor use un correo electrónico diferente."
        }*/

      })

    },

    register_client() {
      
      if(this.nombre_cliente == "" && this.correo_electronico == "") { this.mensaje_error= "Coloque su nombre y correo electrónico." }
      else if(this.nombre_cliente == "") { this.mensaje_error= "Coloque su nombre" }
      else if(this.correo_electronico == "") { this.mensaje_error = "Coloque su correo electrónico" }
      else {
        
        var validEmail  = /.+@.+\..+/
        if(!validEmail.test(this.correo_electronico)) { this.mensaje_error = "Coloque un correo electrónico válido." }
        else { 
          var json_data = {
            "subscriber_name" : this.nombre_cliente,
            "subscriber_email" : this.correo_electronico
            }

            axios({
              method: 'post',
              url: config_settings.RESOURCE_SERVER_URL + '/POST/subscriptions',
              data: json_data
            })
            .then(response => {
              this.mensaje_error = ""
              //this.mensaje = "¡Se ha suscrito correctamente!"
              this.reset_suscription()
            })
            .catch(error => {
              
              if(error.response.status == BAD_REQUEST) {
                //this.mensaje_error = "Hubo un error al registrar su suscripción."
                this.reset_suscription();
              }

              if(error.response.status == CONFLICT) {
                //this.mensaje_error = "El email ya se encuentra en uso. Por favor use un correo electrónico diferente."
              }
            })

            this.bar_suscription = true
          }
        }
    },

    refreshToken(){

          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL + '/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

    listar_categorias() {
      axios.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/categories')
            .then(response => {
              this.categories = response.data;
            })
            .catch(error => {
              console.log('Existe un error: ' + error)
            })
    },

     listar_categorias_padre() {
      axios.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/categories_father')
            .then(response => {
              this.father_categories = response.data;
            })
            .catch(error => {
              console.log('Existe un error: ' + error)
            })
    },

    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {

        this.search_subcategory = subcategory_description;
        this.id_search_subcategory = subcategory_id;

         this.search_data="";

         //console.log("Estamos aqui xd: "+idcategoria)

        //if(this.search_data == '') {
        if(idcategoria == 0) {
          this.$router.push({ name: 'productos' });
        }
        else {
          //console.log("Estamos aqui xd jaaaaa: "+idcategoria)
          let cat;
          typeof idcategoria == undefined || idcategoria == undefined ? cat = 0 : cat = idcategoria;
          this.$router.push("/productos/0/1/"+cat+"/"+this.id_search_subcategory+"/0/0");
        }
        //}
    },

    /* Initially loading the cart products from local storage */

    ...mapMutations(["SET_CART_PRODUCTS", "ADD_LOGGED_USER"]),

    getLocalProducts() {
      const products = JSON.parse(localStorage.getItem("iki-cart"));

      if (products) {
        this.SET_CART_PRODUCTS(products);
      }
    },

    callUserInformation () {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
     })
      .then(response => {
        this.user = response.data;
        this.logged = true
      })
      .catch(error => {
        console.log("Error: "+JSON.stringify(error.response));
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.callUserInformation ();
           })
           .catch(_ => {
              this.logged = false
           });
         }
         this.logged = false
      })
    },

    retornarMensaje(){
      var mensaje = "https://api.whatsapp.com/send?phone=51922442902&text=Estimados!%20Deseo%20Comprar%20los%20siguientes%20productos:%20"
      var contador = 1;
      this.cartProducts.forEach(element => {
        mensaje = mensaje + " " + element.qty + " Unidad(es) del producto " + element.name_product_es + "%20 con SKU: " + element.sku;
        if(contador < this.cartProducts.length){
          mensaje = mensaje + ","
        }
        contador++;
      });
      return mensaje + ".%20Quedo%20atento%20a%20la%20respuesta%20de%20mi%20solicitud.%20Saludos.&source=&data=";
    },

    isLogged() {
      return isLoggedIn();
    },

    loc_logout() {
      this.logged = false;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      this.$router.push("/");
      location.reload();
    }

  },
  
  created() {
    this.callUserInformation();
    this.obtener_secciones();
    this.getLocalProducts();
    this.listar_categorias();
    this.listar_categorias_padre();
    const loggedUser = getLoggedInUser();

    this.ADD_LOGGED_USER(loggedUser);

    console.log(process.env.NODE_ENV);
    console.log(process.env.VUE_APP_BASE_URL);
  }
};

</script>

<style lang="scss">
@import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
@import "./assets/css/ec.css";
@import url('https://fonts.googleapis.com/css?family=Titillium+Web');
@import "./assets/css/personalized_style.css";



#app {
  font-family: "Titillium Web";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  @media(min-width:0px) {
     margin-top: 111px;
  }
  @media(min-width:476px) {
     margin-top: 110px;
  }
  @media(min-width:768px) {
     margin-top: 122px;
  }
  @media(min-width:992px) {
     margin-top: 0px;
  }
}

#navbar-secundario {
  min-height: 18px;
  padding: 0px;
  a {
    font-size: 12px;
    font-weight: bold;
    color: #f4f4f5;
    &.router-link-exact-active {
      color: #c41212;
    }
  }
}

#nav {
  padding: 16px;
  a {
    font-weight: bold;
    color: #f4f4f5;
    &.router-link-exact-active {
      font-weight: bold;
      color: #c41212;
    }
  }
}

.modal-dialog {
      height: 100vh;
      display: flex;
      align-items: center;
}



@media(min-width:0px) {
	.bg-pesca {
    background-color: #1f364c;
  }
}

@media(min-width:992px) {
	.bg-pesca {
    background-color: #2b2b2b73;
  }
}

.nav-link.search-nav-link {
    font-size: 13px;
    padding: 3px;
    padding-left: 10px;
    font-weight: bold;
  }

a.nav-link test search-nav-link:hover > ul.dropdown-submenu {
    display: block;
}


.modal.right .modal-dialog {
	position: fixed;
	margin: auto;
	width: 320px;
	height: 100%;
	-webkit-transform: translate3d(0%, 0, 0);
	-ms-transform: translate3d(0%, 0, 0);
	-o-transform: translate3d(0%, 0, 0);
	transform: translate3d(0%, 0, 0);
}

.modal.right .modal-content {
	height: 100%;
	overflow-y: auto;
}

.modal.right .modal-header{
  border-bottom-color: #ffffff;
  background-color: #ffffff;
}

.modal.right .modal-body {
	padding: 15px 15px 80px;
}

.modal.right.fade .modal-dialog {
	right: -320px;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.right.fade.show .modal-dialog {
	right: 0;
}

/* ----- MODAL STYLE ----- */
.modal-content {
	border-radius: 0;
	border: none;
}

.modal-header {
	border-bottom-color: #eeeeee;
	background-color: #fafafa;
}

/* ----- v CAN BE DELETED v ----- */

.demo {
	padding-top: 60px;
	padding-bottom: 110px;
}

.btn-demo {
	margin: 15px;
	padding: 10px 15px;
	border-radius: 0;
	font-size: 16px;
	background-color: #ffffff;
}

.btn-demo:focus {
	outline: 0;
}

.dropdown-menu {
  margin: .0rem 0 0;
  background-color: #343a40a3;
  font-size: 14px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.dropdown-item{
 font-size: 13px;
}

.dropdown-item:hover{
 background-color: #6d777f59;
}

 
/* makes main-menu open on hover */
.menu-item:hover > .dropdown-menu {
  display: block;
}

/* makes sub-menu S open on hover */
.submenu-item:hover > .dropdown-menu {
  display: block;
  position: relative;
  //left:100%;
  top:10;
}

.submenu-item-2nd:hover > .dropdown-menu {
  display: block ;
  position: relative;
  left:100% !important;
  top:0 !important;
}




@media (max-width:992px){
#navbar1.navbar-collapse.navbars.collapsing{
 border-bottom: silver 2px dotted !important;
 padding-top: 20px;
 a {
    font-size: 14px;
    padding-left: 11px;
    text-align: left;
    font-weight: bold;
    color: #2c3e50;
    text-transform: uppercase;
    &.router-link-exact-active {
      font-weight: bold;
      color: #c41212;
      background-color: #eee2e2;
    } 
    &.cart::before {
      content: "Mi carrito: ";
    }
  }
}


#navbar2.navbar-collapse.navbars.collapsing{
padding-top: 255px;
 a {
    padding-left: 11px;
    text-align: left;
    font-weight: bold;
    color: #2c3e50;
    text-transform: uppercase;
    &::before{
      content: "> ";
    }
    &.router-link-exact-active {
      font-weight: bold;
      color: #c41212;
      background-color: #eee2e2;
    }
    &.telefono{
      color:#fff;
      background-color: #2c3e50;
    }
    
  }
}


#navbar1.collapse.navbar-collapse.show{
 border-bottom: silver 2px dotted !important;
 padding-top: 20px;
 a {
    font-size: 14px;
    padding-left: 11px;
    text-align: left;
    font-weight: bold;
    color: #2c3e50;
    text-transform: uppercase;
    &.router-link-exact-active {
      font-weight: bold;
      color: #c41212;
      background-color: #eee2e2;
    } 
    &.cart::before {
      content: "Mi carrito: ";
    }
  }
}

#navbar2.collapse.navbar-collapse.show{
 padding-top: 20px;
 background-color: #181e2a82;
 a {
    padding-left: 11px;
    text-align: left;
    font-weight: bold;
    color: #e5e8eb;;
    text-transform: uppercase;
    &::before{
      content: "- ";
    }
    &.router-link-exact-active {
      font-weight: bold;
      color: #c41212;
      background-color: #eee2e2;
    }
    &.telefono{
      color:#fff;
      background-color: #e5e8eb;
    }
    
  }
}
}

.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #c41212 !important;
}

.container-fluid {
    height: 20px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.btn-unico {
    font-size: 13px !important;
    padding: 0 15px !important;
    margin: 5px 5px !important;
    margin-left: 0px !important;
}

html {
  position: relative;
  min-height: 100%;
}

* a {
  color: #d02031;
}

* .fa {
  font-size: 18px;
}

.buttonGreen-outline {
  width: 100%;
  color: #41b883;
  background-color: transparent;
  border-color: #41b883;
}
.buttonGreen-outline:hover {
  color: #ffffff;
  background-color: #41b883;
  border-color: #41b883;
}

.buttonGreen {
  color: #fff;
  background-color: #41b883;
}

.buttonGreen:hover {
  background-color: #42a97b;
}

.dropdown:hover .dropdown-menu {
    display: block;
    margin-top: 0; // remove the gap so it doesn't close
 }


.submenu-item {
    position: relative;
}

@media (min-width: 992px){

.navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
}
}
 
  section {
    padding: 60px 0;
}

section .section-title {
    text-align: center;
    color: #007b5e;
    margin-bottom: 50px;
    text-transform: uppercase;
}
#footer {
    background: #dedede !important;
}
#footer h5{
	padding-left: 10px;
    border-left: 3px solid #4e4e4e;
    padding-bottom: 6px;
    margin-bottom: 20px;
    color:#ffffff;
}
#footer a {
    color: #4e4e4e;
    background-color: transparent;
    text-decoration: none;
    font-size: 14px;
    -webkit-text-decoration-skip: objects;
}
#footer p {
    color: #4e4e4e;
    padding-top: 10px;
    font-size: 14px;
    text-decoration: none !important;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
#footer ul.social li{
	padding: 3px 0;
}
#footer ul.social li a i {
    margin-right: 5px;
	font-size:25px;
	-webkit-transition: .5s all ease;
	-moz-transition: .5s all ease;
	transition: .5s all ease;
}
#footer ul.social li:hover a i {
	font-size:30px;
	margin-top:-10px;
}
#footer ul.social li a,
#footer ul.quick-links li a{
	color:#ffffff;
}
#footer ul.social li a:hover{
	color:#eeeeee;
}
#footer ul.quick-links li{
	padding: 3px 0;
	-webkit-transition: .5s all ease;
	-moz-transition: .5s all ease;
	transition: .5s all ease;
}
#footer ul.quick-links li:hover{
	padding: 3px 0;
	margin-left:5px;
	font-weight:700;
}
#footer ul.quick-links li a i{
	margin-right: 5px;
}
#footer ul.quick-links li:hover a i {
    font-weight: 700;
}

.search-control{
    font-size: 9px;
    background-color: #c8c9cc82;
    border: 2px solid #c8c9cc82;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    
}

.search-buttons {
  
  background: #c8c9cc82;
  font-size: 13px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.fixed-top-2 {
    margin-top: 78px;
}


@media (max-width:767px){
	#footer h5 {
    padding-left: 0;
    border-left: transparent;
    padding-bottom: 0px;
    margin-bottom: 10px;
}
}

@media (max-width:993px){
	.search-control{
        width: 1% !important;
}
}

@media (max-width:575px){
  .quick-links-primary {
        margin-bottom: 0px;
  }
}

#toTop{
	position: fixed;
	bottom: 10px;
	right: 10px;
	cursor: pointer;
	display: none;
}

.toast {
  background-color: #65ca22;
}

.p-footer{
 text-align: justify !important;
}

.form-control {
  font-size: 13.5px;
  
}

.toggler-armaq {
      border: 0px solid transparent;
}

.toggler-armaq-icon {
    width: 1.25em;
    height: 1.25em;
}

.fa-networks {
  padding: 7px;
  font-size: 15px;
  width: 30px;
  text-align: center;
  text-decoration: none;
  border-radius: 50%;
}

/* Add a hover effect if you want */
.fa-networks:hover {
  opacity: 0.7;
}

/* Set a specific color for each brand */

/* Facebook */
.fa-facebook {
  background: #f4f4f5;
  color: #3B5998 !important;
}

/* Twitter */
.fa-instagram {
  background: #e543ab;
  color: #faf8f9;
}

    

.webform-twomodules {
  background-color: transparent !important;
  left: inherit !important;
  right: 0px !important;
  padding: inherit !important;
  box-shadow: inherit !important;
  transform: inherit !important;
  position: relative !important;
  margin: inherit !important;
  display: inline !important;
  font-family: "Titillium Web" !important;
}



.button-left-subscription {
  font-size: 12.5px;
  height: 45px;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.button-right-subscription {
  font-size: 12.5px;
  height: 45px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

.modal-subscription {
  border-radius: 15px !important;
}

.input-subscription {
	padding: 12px 20px;
	margin: 9px 0;
	box-sizing: border-box;
	border-radius: 10px !important;
	outline: none;
	width: 100%;
	height:20%;
	font-size: 14px;
}


.facebook-mobile{
  display: none;

  @media(min-width:768px) {
     display: inline-block;
  }
}
</style>
